import { makeStyles } from '@material-ui/core';
var transferStyles = makeStyles(function (theme) { return ({
    headerRow: {
        backgroundColor: theme.palette.primary.light,
        textTransform: "capitalize"
    },
    tableContainer: {
        position: "relative"
    },
    buttonContainer: {
        position: "absolute",
        right: "15px",
        bottom: "10px"
    },
    transferHead: {
        padding: "7px 7px"
    }
}); });
export default transferStyles;
//# sourceMappingURL=styles.js.map